import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import fourDotImg from '../images/ARCADE-DOTS.png'

function Footer() {
    return (
        <div>
            <Row style={{ margin: 0 }}>
                <Col style={{ paddingTop: '4vh', color: "white" }}>
                    <h4 style={{ textAlign: 'center', fontStretch: 'expanded', marginBottom: '2rem' }}>CONTACT</h4>
                    <p>contact@devaltus.com</p>
                </Col>
                <Col>
                    <img src={fourDotImg} height={140} alt='' />                   
                </Col>
                <Col style={{ paddingTop: '4vh', color: "white" }}>
                    
                    <h4 style={{ textAlign: 'center', fontStretch: 'expanded', marginBottom: '2rem' }}>FOLLOW</h4>
                    
                </Col>
            </Row>

        </div>
    );

}

export default Footer;